/*eslint-disable*/
import vars from '../../../../vars.js';

let technicalCookies = true;
let trackingCookies = true;
let googleAnalyticsID = vars.googleAnalyticsID

const launchAnalytics = () => {
  let script1 = document.createElement('script');
  script1.type = 'text/javascript';
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsID}`;
  script1.async = '';

  let script2 = document.createElement('script');
  script2.type = 'text/javascript';
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${googleAnalyticsID}');`;
    
  let script3 = document.createElement('script');
  script3.type = 'text/javascript';
  script3.innerHTML = `
    function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
          'send_to': 'AW-567500731/NCUUCNrYwuEBELu_zY4C',
          'event_callback': callback
      });
      return false;
    }`;

  let script4 = document.createElement('script');
  script4.type = 'text/javascript';
  script4.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '140105276664157'); 
    fbq('track', 'PageView');
  `;
  // <noscript>
  //   <img height="1" width="1" 
  //   src="https://www.facebook.com/tr?id=140105276664157&ev=PageView
  //   &noscript=1"/>
  // </noscript>

  document.head.appendChild(script1);
  document.head.appendChild(script2);
  document.head.appendChild(script3);
  document.head.appendChild(script4);
}

const setHideBannerCookie = () => {
  $.cookie('hide-banner', true, {
    expires: 7,
    path: '/'
  });
}

const CookiesBox = ((($) => {
  function init() {

    // Init at true
    $('#toggle-all').prop("checked", true);
    $('#toggle-all').parent().addClass('checked')
    technicalCookies = true;
    $('#technical').prop("checked", true);
    $('#technical').parent().addClass('checked')
    trackingCookies = true;
    $('#tracking').prop("checked", true);
    $('#tracking').parent().addClass('checked')


    $('#toggle-all').on('click', (e) => {
      if(!e.target.checked) {
        technicalCookies = true;
        $('#technical').prop("checked", true);
        $('#technical').parent().addClass('checked')
        trackingCookies = true;
        $('#tracking').prop("checked", true);
        $('#tracking').parent().addClass('checked')
      } else {
        technicalCookies = false;
        $('#technical').prop("checked", false);
        $('#technical').parent().removeClass('checked')
        trackingCookies = false;
        $('#tracking').prop("checked", false);
        $('#tracking').parent().removeClass('checked')
      }
    });

    $('#technical').on('click', (e) => {
      technicalCookies = !e.target.checked;
    });

    $('#tracking').on('click', (e) => {
      trackingCookies = !e.target.checked;
    });

    $('.close-popup').on('click', function(e) {
      $(this).parents('#cookiesbanner').fadeOut('fast');
    });

    $('#cookies-ok, #cookies-save').on('click', function(e) {
      e.preventDefault();
      $(this).parents('#cookiesbanner').fadeOut('fast');

      if (technicalCookies) {
        setHideBannerCookie();
      }

      if (trackingCookies && googleAnalyticsID) {
        launchAnalytics();
      }
      else if (technicalCookies) {
        $.cookie('no-analytics', true, {
          expires: 7,
          path: '/',
        });
      }
    });

    $('.expand-cookies').on('click', function() {
      $(this).toggleClass('active');
      $('.banner-cookies_expanded').toggleClass('visible');
    });

    if (!$.cookie('hide-banner')) {
      setTimeout($('#cookiesbanner').css('display', 'block'), 1000);
    }
    else if (!$.cookie('no-analytics')) {
      launchAnalytics();
    }
  }

  return {
    init,
  };
}))(jQuery);

export default CookiesBox;



// WEBPACK FOOTER //
// ./src/static/js/modules/cookies.js